export default __webpack_public_path__ + "static/media/mlr-3-rMAX.7eeb5686.avif";